var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit_black_24dp_2_",
    "data-name": "edit_black_24dp (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.573,
    height: 15.574,
    viewBox: "0 0 15.573 15.574",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7271",
    "data-name": "Path 7271",
    d: "M0,0H15.574V15.574H0Z",
    transform: "translate(0 0)",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7272",
    "data-name": "Path 7272",
    d: "M10.177,6.906l.6.6L4.895,13.382H4.3v-.6l5.879-5.879M12.513,3a.65.65,0,0,0-.454.188L10.871,4.376,13.3,6.809l1.187-1.187a.646.646,0,0,0,0-.915L12.974,3.188A.637.637,0,0,0,12.513,3ZM10.177,5.07,3,12.247V14.68H5.433L12.61,7.5,10.177,5.07Z",
    transform: "translate(-1.053 -1.053)",
    fill: "#6676aa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.84d41c1d32bb763cbaaebd691a132865.svg";
export { ForwardRef as ReactComponent };